import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { Lookup } from "src/app/models/lookup.model";
import { ColumnSpan } from "src/app/shared/form/columnSpan.model";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import { MultiSelectionFormField } from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import { AnalyticalMethodService } from "../services/analytical-method.service";
import { AnalyticalMethod } from "../models/analyticalMethod.model";
import { SampleMediaService } from "../services/sample-media.service";

export interface IMediaToAnalyticalMethodData extends IFormDialogData {
    id: string;
    methodName: string;
    agency: string;
    instrumentation: string;
    description: string;
    url: string;
    sampleMediaIds?: string[];
}

@Component({
  standalone: false,
    selector: "app-media-to-analytical-method-dialog",
    templateUrl: "./../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../shared/form/form.component.scss"],
})
export class MediaToAnalyticalMethodDialogComponent
    extends FormComponent<AnalyticalMethod>
    implements OnInit
{
    sampleMediaList: Lookup[] = [];
    filteredAgents: Lookup[] = [];

    constructor(
        dialogRef: MatDialogRef<MediaToAnalyticalMethodDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IMediaToAnalyticalMethodData,
        protected sampleMediaService: SampleMediaService,
        protected analyticalMethodService: AnalyticalMethodService,
        protected injector: Injector,
    ) {
        super(
            dialogRef,
            analyticalMethodService,
            data,
            "Analytical Method",
            injector,
        );
        this.title = this.translateService.getDynamicTranslation(
            "Add media to Analytical Method",
        );
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        forkJoin({
            sampleMedia: this.sampleMediaService.getAll(),
        }).subscribe(
            (result) => {
                this.entity = this.data;
                this.sampleMediaList = result.sampleMedia;
                this.filteredAgents = [...result.sampleMedia];
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): AnalyticalMethod {
        return new AnalyticalMethod();
    }

    validate(): boolean {
        if (!this.entity.sampleMediaIds?.length) {
            this.toastService.displayErrorMessage(
                "Please select at least one Media",
                true,
            );
            return false;
        }
        return true;
    }

    initFields(): void {
        this.fields = [
            new MultiSelectionFormField({
                property: nameOf((x: AnalyticalMethod) => x.sampleMediaIds),
                name: "Select Sample Media",
                options: this.filteredAgents,
                columnSpan: new ColumnSpan(2, 2),
            }),
        ];
    }
}
